export default __webpack_public_path__ + "static/101211-b47ddee3d560170143adea6c60b80c2f.jpg";